import { Career } from '../api/app-types/career.app';
import { ParticipationStatus } from '../api/app-types/participation-status.app';
import { SocialSecurityStatus } from '../api/app-types/social-security-status.app';
import { Workplace } from '../api/app-types/workplace.app';
import { mockWorkplaceJobs } from './workplace.mock';

export const participationStatusMocks: ParticipationStatus[] = [
	{
		id: 1,
		guid: 'a1b2c3d4-e5f6-7g8h-9i0j-k1l2m3n4o5p6',
		initial: 'ANG',
		remark: 'Angemeldet',
	},
	{
		id: 2,
		guid: 'b1c2d3e4-f5g6-7h8i-9j0k-l1m2n3o4p5q6',
		initial: 'EIN',
		remark: 'Eingetroffen',
	},
	{
		id: 3,
		guid: 'c1d2e3f4-g5h6-7i8j-9k0l-m1n2o3p4q5r6',
		initial: 'ABG',
		remark: 'Abgemeldet',
	},
];

export const socialSecurityStatusMocks: SocialSecurityStatus[] = [
	{
		guid: 'd1e2f3g4-h5i6-7j8k-9l0m-n1o2p3q4r5s6',
		id: 1,
		initial: 'SVP',
		remark: 'Sozialversicherungspflichtig',
		statusActivity: 1,
	},
	{
		guid: 'e1f2g3h4-i5j6-7k8l-9m0n-o1p2q3r4s5t6',
		id: 2,
		initial: 'SVF',
		remark: 'Sozialversicherungsfrei',
		statusActivity: 1,
	},
];

export const careerMocks: Career[] = [
	{
		id: 1,
		participationStatus: participationStatusMocks[0],
		socialSecurityStatus: socialSecurityStatusMocks[0],
		startOfCareerStage: new Date('2022-01-01'),
		workplacesJob: mockWorkplaceJobs[0],
		isFrozen: false,
	},
	{
		id: 2,
		participationStatus: participationStatusMocks[1],
		socialSecurityStatus: socialSecurityStatusMocks[1],
		startOfCareerStage: new Date('2022-02-01'),
		endOfCareerStage: new Date('2023-02-01'),
		workplacesJob: mockWorkplaceJobs[0],
		isFrozen: false,
	},
];

export const workplaceMocks: Workplace[] = [
	{
		id: 1,
		name: 'Musterfirma GmbH',
		address: {
			anonym: '',
			id: 1,
			identifier: '',
			postalCodeAndCity: '12345 Musterstadt',
			soundexStreet: 'Musterstraße 1',
			streetAndHouseNumber: 'Musterstraße 1',
		},
		cityDistrict: {
			display: 'Musterstadt',
			initial: 'MS',
			remark: 'Musterstadt',
			specialistIntegrationService: '',
		},
		workplacesJobs: mockWorkplaceJobs,
		contactPoints: [],
		institutionPersons: [],
		industryName: '',
		isMainInstitution: false,
	},
];
